import { get, isEmpty } from 'lodash';
import { ICellRendererParams } from 'ag-grid-community';

import { XVII18nService } from '@app/i18n/services';
import { I18n } from '@app/i18n/strings-keys';
import { getIsSomeChildNotSame } from '../helpers/ag-grid-helpers/ag-grid-helpers';

/**
 * Get varies placeholder function
 * Will return 'Varies' if the row value is empty and the row is not a leaf node
 *
 * @param options
 * @returns
 */
export const getVariesPlaceholderFunc =
  (options: { i18nService: XVII18nService; emptyPlaceHolder?: string }) =>
  (placeHolderParams: ICellRendererParams) => {
    if (get(placeHolderParams, 'data.isLeaf', false)) {
      return null;
    }

    const { i18nService, emptyPlaceHolder = I18n.Common.Varies } = options;

    const rowValue = placeHolderParams.value;

    if (!isEmpty(rowValue)) {
      return null;
    }

    const someChildNotSame = getIsSomeChildNotSame({
      rowValue,
      rowNode: placeHolderParams.node,
      rowField: placeHolderParams.colDef.field || '',
    });

    return someChildNotSame ? i18nService.t(emptyPlaceHolder) : null;
  };
